declare var M: any;
export const catchError = (au, msg: string, actions: string) => {
  let status: boolean = false;
  au.subscribe(stats => (status = stats));
  M.toast({
    html: `<i class="material-icons left">block</i>${
      status ? msg.toString().slice(40) : "Login Required"
    }!`,
    classes: "rounded red lighten-1"
  });
};
